import React from 'react';
export function ForWho() {
  const items = [{
    title: 'Terminas antes de lo que quisieras',
    desc: 'Y eso te genera vergüenza, frustración o directamente evitas la intimidad.'
  }, {
    title: 'La ansiedad te bloquea antes de empezar',
    desc: 'Tu mente empieza a presionarte y eso arruina el momento antes de que siquiera comience.'
  }, {
    title: 'Quieres durar más y dar más placer',
    desc: 'No solo aguantar más tiempo, sino realmente saber cómo llevarla al límite del placer.'
  }, {
    title: 'Tu confianza en la cama bajó',
    desc: 'Ya no eres el mismo de antes y eso se siente en todas las áreas de tu vida.'
  }, {
    title: 'Probaste soluciones que no funcionaron',
    desc: 'Consejos de internet, pensar en otra cosa, cremas... nada dio resultado real.'
  }, {
    title: 'Quieres un método concreto y privado',
    desc: 'Sin ir a un médico incómodo, sin pastillas, sin que nadie tenga que enterarse.'
  }];
  return <section className="py-[36px] px-5 bg-brand-black" data-id="element-72">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-73">
        <h2 className="font-montserrat font-black text-[clamp(1.5rem,4vw,2.4rem)] text-brand-white uppercase text-center mb-2 leading-[1.15]" data-id="element-74">
          ¿Este Sistema
          <br data-id="element-75" />
          <span className="text-brand-red" data-id="element-76">Es para Ti?</span>
        </h2>
        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mt-[10px] mb-[22px] rounded-[2px]" data-id="element-77"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-2.5" data-id="element-78">
          {items.map((item, idx) => <div key={idx} className="bg-brand-black-card border border-[#1f1f1f] rounded-[10px] p-[22px_20px] flex items-start gap-[14px] transition-colors duration-300 hover:border-brand-red group" data-id="element-79">
              <div className="shrink-0 w-[36px] h-[36px] bg-brand-red rounded-full flex items-center justify-center text-white text-base" data-id="element-80">
                ✓
              </div>
              <div data-id="element-81">
                <h4 className="font-montserrat text-[0.9rem] font-bold text-brand-white uppercase tracking-[0.5px] mb-[5px]" data-id="element-82">
                  {item.title}
                </h4>
                <p className="text-[0.88rem] text-[#908b83] leading-[1.5]" data-id="element-83">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}